module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "scale-vertically"
    }
  }, [(_vm.isOpen) ? _c('div', {
    directives: [{
      name: "on-click-outside",
      rawName: "v-on-click-outside",
      value: (_vm.hide),
      expression: "hide"
    }],
    staticClass: "UpgradeDropdown__info",
    class: {
      'pro': _vm.subscription.active
    }
  }, [_c('div', {
    staticClass: "UpgradeDropdown__info-header"
  }, [_c('i', {
    staticClass: "icon-ic_star UpgradeDropdown__info-icon"
  })]), _vm._v(" "), _c('div', {
    staticClass: "UpgradeDropdown__info-body"
  }, [(!_vm.subscription.active) ? _c('div', {
    staticClass: "UpgradeDropdown__info-message"
  }, [_c('div', {
    staticClass: "UpgradeDropdown__info-title"
  }, [_vm._v("\n          Upgrade to PRO\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "UpgradeDropdown__info-text"
  }, [_vm._v("\n          Enjoy up to 100 Participants in a meeting for just $20/month.\n          You need to download the app to upgrade to PRO.\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "UpgradeDropdown__info-links"
  }, [_c('a', {
    staticClass: "UpgradeDropdown__info-link",
    attrs: {
      "target": "_blank",
      "href": "https://itunes.apple.com/app/kingsconference/id1215191816?mt=8"
    }
  }, [_vm._v("\n            go to appstore\n          ")]), _vm._v(" "), _c('a', {
    staticClass: "UpgradeDropdown__info-link",
    attrs: {
      "target": "_blank",
      "href": "https://play.google.com/store/apps/details?id=com.newmedia.conference&hl=en"
    }
  }, [_vm._v("\n            go to playstore\n          ")])])]) : _vm._e(), _vm._v(" "), (_vm.subscription.active) ? _c('div', {
    staticClass: "UpgradeDropdown__info-pro-message"
  }, [_c('div', {
    staticClass: "UpgradeDropdown__info-title"
  }, [_vm._v("\n          You're now a PRO User\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "UpgradeDropdown__info-text"
  }, [_vm._v("\n          Congratulations! You can now have meetings with up to 100 participants.\n        ")])]) : _vm._e()])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-701d8e65","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/upgrade-dropdown/upgrade-dropdown.vue
// module id = 431
// module chunks = 1